<template lang='pug'>
  .products-carousel(:class='entityOptions.type')
    template(v-if='entityOptions')
      h2.page-title.title(v-if='entityOptions.title')
        router-link(:to='entityOptions.link' v-text='entityOptions.title' v-if='entityOptions.link')
        span(v-text='entityOptions.title' v-else)
      h3.subtitle(v-if='entityOptions.subtitle' v-text='entityOptions.subtitle')
      slider(
        carouselType='product'
        :containerClass='containerClass'
        :autoplay='autoplay'
        :items='defaultItemsForBreakpoint("lg")'
        :slideBy='defaultItemsForBreakpoint("lg")'
        :speed='speed'
        :loop='loop'
        :nav='false'
        :gaOptions='gaOptions'
        :showArrows='hasArrows'
        :responsiveOptions='responsiveOptions'
        @indexChanged='indexChangedCallback'
        @cloneCountChanged='cloneItems',
        ref='sliderRef'
      )
        .wrapper(slot='slider-content')
          .product-slider(:class='containerClass')
            span.tns-item(v-if='products.length > 0' v-for='(product, index) in loopedProducts' :key='`products-carousel-${product.id}-${index}`')
              product-card(
                v-bind='productCardOptions(product)'
                :gaOptions='{ ...gaOptions, cardSequenceNumber: index + 1 }'
                :showHeart='entityOptions.showHeart'
              )
            span.tns-item(v-for='reward in rewards' v-if='rewards.length > 0')
              reward-card(:reward='reward' :key='`reward-${reward.id}`')
</template>

<script>
import { get } from 'lodash/object'
import ProductCard from './product-card.vue'
import RewardCard from '@/components/account/beauty-pass/reward-card.vue'
import Slider from '@/components/shared/slider.vue'
import { adjustLoopedItems } from '@/modules/services/tiny-slider'

export default {
  components: {
    ProductCard,
    RewardCard,
    Slider
  },

  props: {
    entityOptions: {
      type: Object,
      required: true
    },
    carouselOptions: {
      type: Object,
      required: true
    },
    gaOptions: {
      type: Object,
      default: () => {}
    },
    products: {
      type: Array,
      required: true
    },
    variants: {
      type: Array,
      required: true
    },
    rewards: {
      type: Array,
      required: false
    },
    autoplay: {
      type: Boolean,
      required: true
    },
    loop: {
      type: Boolean,
      default: true
    },
    speed: {
      type: Number,
      default: 1000
    },
    indexChangedCallback: {
      type: Function,
      default: () => {}
    }
  },

  data () {
    return {
      frontProducts: [],
      rearProducts: []
    }
  },

  computed: {
    isMobile: () => vueSupport.isMobile,
    isTablet: () => vueSupport.isTablet,
    hasArrows () {
      var items = this.isTablet ? this.responsiveOptionsFor('md').items : this.responsiveOptionsFor('lg').items
      return !this.isMobile && this.products.length > items
    },
    containerClass () {
      return this.carouselOptions.sliderClass ? this.carouselOptions.sliderClass : 'product-slider'
    },

    responsiveOptions () {
      return {
        0: { // Mobile
          autoplay: false,
          mouseDrag: true,
          items: this.responsiveOptionsFor('sm').items,
          slideBy: this.responsiveOptionsFor('sm').slideBy
        },
        576: { // Tablet Portrait
          autoplay: this.autoplay,
          mouseDrag: true,
          items: this.responsiveOptionsFor('md').items,
          slideBy: this.responsiveOptionsFor('md').slideBy
        },
        992: { // Laptop & Tablet Landscape
          autoplay: this.autoplay,
          mouseDrag: this.isTablet,
          items: this.responsiveOptionsFor('lg').items,
          slideBy: this.responsiveOptionsFor('lg').slideBy
        }
      }
    },

    loopedProducts () {
      return this.frontProducts.concat(this.products).concat(this.rearProducts)
    }
  },

  methods: {
    productCardOptions (product) {
      return {
        product: product,
        variants: this.variantList(product),
        size: this.carouselOptions.size || 'sm',
        gaClasses: this.gaOptions ? this.gaOptions.classes : [],
        imageSize: 'default-image-urls'
      }
    },

    variantList (product) {
      return this.variants.filter(variant => variant.relationships.product.data.id === product.id)
    },

    defaultItemsForBreakpoint (breakpoint) {
      switch (breakpoint) {
        case 'sm':
          return 2
        case 'md':
          return 2
        case 'lg':
          return 3
      }
    },

    responsiveOptionsFor (breakpoint) {
      return {
        items: get(this, `carouselOptions.responsive.${breakpoint}.items`) || this.defaultItemsForBreakpoint(breakpoint),
        slideBy: get(this, `carouselOptions.responsive.${breakpoint}.slideBy`) || this.defaultItemsForBreakpoint(breakpoint)
      }
    },

    cloneItems () {
      [this.frontProducts, this.rearProducts] = adjustLoopedItems(this.$refs.sliderRef.slider, this.products)
    }
  }
}
</script>

<style scoped lang='scss'>
  // Some inline transform CSS is adding in the product carousel and that CSS is affecting UI. So, used !important for that.
  .rewards-carousel {
    transform: none !important;
  }

  .title {
    text-align: center;
    margin-bottom: 10px;
  }
</style>
